/* @flow */
import AffiliationStatus from 'organizations/components/AffiliationStatus.jsx';
import AuthActions from 'auth/AuthActions';
import React from 'react';

import 'organizations/components/styles/SchoolAdminPending.scss';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

class AdminDesktopUpsellPage extends React.Component {
  // This has to be here in order to get a CurrentUser
  static onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function,
  ) {
    AuthActions.checkLoggedIn().then(
      () => callback(),
      () => callback());
  }

  render() {
    return (
      <div className="SchoolAdminPending">
        <AffiliationStatus
          title="We're verifying your status"
          subtext="Verifying administrators usually takes 1 to 3 business days, and you'll get an
          email as soon as we're done!">
          <div className="AffiliationStatus-Subtext">
            Please log in on your computer to use Remind for Schools.
          </div>
        </AffiliationStatus>
      </div>
    );
  }
}

export default AdminDesktopUpsellPage;



// WEBPACK FOOTER //
// ./src/admin/components/AdminDesktopUpsellPage.jsx